import { Upload } from "antd";
import Swal from "sweetalert2";
import AWS from "aws-sdk";
import { useRef } from "react";
import { v4 as uuidv4 } from "uuid";

const UploadButton = ({ onChange, disabled }) => {
  const S3_BUCKET = "followvita.com";
  const REGION = "us-east-2";

  AWS.config.update({
    accessKeyId: import.meta.env.VITE_ACCESS_KEY_ID,
    secretAccessKey: import.meta.env.VITE_SECRET_ACCESS_KEY,
  });

  const s3 = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const requestCountRef = useRef(0);
  const resetTimeoutRef = useRef(null);

  const uploadFile = async (file) => {
    const uniqueFileName = `${uuidv4()}_${file.name}`;
    const params = {
      Bucket: S3_BUCKET,
      Key: `src/${uniqueFileName}`,
      Body: file,
      ContentType: file.type,
    };
    try {
      const data = await s3.upload(params).promise();
      return data.Location;
    } catch (error) {
      console.error("Error uploading file:", error);
      Swal.fire(
        "Upload failed",
        "File upload failed. Please try again.",
        "error"
      );
      return null;
    }
  };

  const handleImageChange = async ({ file }) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      Swal.fire(
        "Invalid file type",
        "You can only upload JPG/PNG files.",
        "error"
      );
      return;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      Swal.fire("File too large", "Image must be smaller than 2MB.", "error");
      return;
    }

    if (requestCountRef.current >= 10) {
      Swal.fire(
        "Limit exceeded",
        "Maximum 10 uploads every 40 seconds.",
        "warning"
      );
      return;
    }

    requestCountRef.current++;
    const uploadedImageURL = await uploadFile(file.originFileObj || file);
    if (uploadedImageURL) {
      onChange(uploadedImageURL);
    }

    if (!resetTimeoutRef.current) {
      resetTimeoutRef.current = setTimeout(() => {
        requestCountRef.current = 0;
        resetTimeoutRef.current = null;
      }, 40000);
    }
  };

  return (
    <Upload
      maxCount={1}
      showUploadList={false}
      onChange={handleImageChange}
      beforeUpload={() => false}
      disabled={disabled}
      className="upload-button-wrapper"
    >
      <div className="choose-photo-button">Choose photo</div>
    </Upload>
  );
};

export default UploadButton;

// Add these CSS styles
const styles = `
.upload-button-wrapper {
    position: relative;
    display: inline-block;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
}

.choose-photo-button {
    padding: 8px 24px;
    border: 1px solid #3371EB;
    border-radius: 4px;
    color: #3371EB;
    background-color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
        cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;
}

.choose-photo-button:hover {
    background-color: #3371EB;
    color: white;
    opacity: 0.8;
}

.upload-button-wrapper.disabled .choose-photo-button {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
}
`;

// Inject styles
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
